import { __assign } from "tslib";
import * as React from 'react';
import { StyleWrapperComponent } from './WeeklyMobileCalendar.styles';
import WeeklyMobileCalendarFunc from './WeeklyMobileCalendarFunc';
import WixStylesContext from '../../../context/wixStylesContext';
var WeeklyMobileCalendarStyled = function () {
    var _a = React.useContext(WixStylesContext), todayBorderColor = _a.todayBorderColor, eventTitleFont = _a.eventTitleFont, calendarBackgroundColorWithoutOpacity = _a.calendarBackgroundColorWithoutOpacity, cellBorderColor = _a.cellBorderColor, cellBorderWidth = _a.cellBorderWidth;
    var eventPadding = '1px 0 1px 1px';
    var fcTimegridColPaddingRight = '1px';
    var fcTimegridColPaddingLeft = '0';
    if (cellBorderWidth === 2) {
        eventPadding = '1px 1px 2px 0';
        fcTimegridColPaddingRight = '1px';
        fcTimegridColPaddingLeft = '1px';
    }
    if (cellBorderWidth === 3) {
        eventPadding = '2px 1px 2px 0';
        fcTimegridColPaddingRight = '2px';
        fcTimegridColPaddingLeft = '2px';
    }
    var styledProps = {
        eventTitleFont: eventTitleFont,
        calendarBackgroundColor: calendarBackgroundColorWithoutOpacity,
        cellBorderColor: cellBorderColor,
        cellBorderWidth: cellBorderWidth,
        todayBorderColor: todayBorderColor,
        eventPadding: eventPadding,
        fcTimegridColPaddingRight: fcTimegridColPaddingRight,
        fcTimegridColPaddingLeft: fcTimegridColPaddingLeft,
    };
    React.useEffect(function () {
        var removeElementsByClass = function (className, position) {
            document.getElementsByClassName(className)[position].remove();
        };
        removeElementsByClass('fc-scrollgrid-section', 1);
    }, []);
    return (React.createElement(StyleWrapperComponent, __assign({}, styledProps),
        React.createElement(WeeklyMobileCalendarFunc, null)));
};
export default WeeklyMobileCalendarStyled;
//# sourceMappingURL=WeeklyMobileCalendarStyled.js.map